import {Modal} from "bootstrap";
import scrollHandler from "./scrollHandler";
import MatchHeight from 'vanilla-js-match-height';
import {matchMediaLGUp} from "./mediaQuery.js"
import {parents} from "./utilities.js";

/* Bundle js */
document.addEventListener('DOMContentLoaded', () => {
    scrollHandler();

    /**
     * Match height
     */
    new MatchHeight('.same-height');
});

const secondaryMenuModal = document.getElementById('secondaryMenuModal');
if (secondaryMenuModal) {
    secondaryMenuModal.addEventListener('show.bs.modal', () => {
        window.scroll({top: 0, left: 0});
    });
}

/**
 * Search input focus
 */
document.body.addEventListener('click', (e) => {
    if (e.target.closest('#search-trigger')) {
        setTimeout(() => document.getElementById('s-1')?.focus(), 800);
    }
});

/**
 * TODO a11y details
 */
/*
document.body.addEventListener('click', (e) => {
    if (e.target.closest('details')) {
        const detailParent = parents(e.target, 'details');
        if (!detailParent) return;

        detailParent[0].classList.toggle('open');
    }
});*/
